import {
  HIDE_NAVIGATION,
  DISPLAY_NAVIGATION,
  SET_LANGUAGE,
} from "@flow/store/navigation/constants";

const initialState = {
  visible: false,
  appLanguage: {
    code: "en",
    path: "/en/",
    tag: "en-US",
  },
  lang_versions: {}
};

const navigationReducer = (state = initialState, action: any) => {
  const {
    type,
    visible,
    appLanguage,
    lang_versions
  } = action;

  switch (type) {
    case HIDE_NAVIGATION:
    case DISPLAY_NAVIGATION:
      return Object.assign({}, state, { visible });
    case SET_LANGUAGE:
      return Object.assign({}, state, { appLanguage, lang_versions });
    default:
      return state;
  }
};

export {
  navigationReducer,
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/navigation/reducer.ts